<script>
  export default {
    props: {
      mensagem: {
        type: Array,
        required: true,
      }
    },
    methods: {

    }
  }
</script>

<style scoped>
  .container {
    border: 2px solid #dedede;
    background-color: #f1f1f1;
    border-radius: 5px;
    padding: 10px;
    margin: 10px 0;
    width: 100%;
  }

  .darker {
    border-color: #ccc;
    background-color: #ddd;
  }

  .container::after {
    content: "";
    clear: both;
    display: table;
  }

  /* Style time text */
  .time-right {
    float: right;
    color: #aaa;
    padding-top: 15px;
  }

  /* Style time text */
  .time-left {
    float: left;
    color: #999;
    padding-top: 15px;
  }

  .texto {
    font-family: Verdana,sans-serif;
    font-size: 14px;
    line-height: 1.5;
    font-weight: normal;
  }
</style>

<template>
  <div>
    <div class="table-responsive" v-if="mensagem.length > 0">
      <div :class="['container', ((index % 2) == 0 ) ? '' : 'darker']" v-for="(item, index) in mensagem">
        <p class="texto">{{ item.campoMensagem }}</p>
        <span :class="[((index % 2) == 0 ) ? 'time-right' : 'time-left']">
          {{item.usuarioSistema }} - {{item.dataHora | formatarData }} às {{item.dataHora | formatarHora }}
        </span>
      </div>
    </div>

    <div class="table-responsive" v-if="mensagem.length == 0">
      <div :class="container">
        <p class="texto">Nenhuma mensagem encontrada.</p>
        <span class="time-right">
          Master Manager Web - {{new DateTime() | formatarData }} às {{new DateTime() | formatarHora }}
        </span>
      </div>
    </div>
  </div>
</template>




// WEBPACK FOOTER //
// FrontEnd/modulos/mensagem/componentes/MensagensConteiner.vue